import styled from 'styled-components';

export const Price = styled.div.withConfig({ componentId: 'sc-1ajy5lv-0' })`
    font-size: var(--font-size-large);
    font-weight: var(--font-weight-bold);
`;
